import { Option } from "api/common/types/common.types";

export {
  YES_NO_OPTIONS,
  YES_NO_MAYBE_OPTIONS,
} from "components/Forms/data/options";

export const KICKOFF_STATUS_OPTIONS: Option[] = [
  { label: "Yes", value: "Recommended for Kickoff" },
  { label: "No", value: "!Recommended for Kickoff" },
];

export const CONFORMANCE_TYPE_OPTIONS = [
  { label: "Any", value: "any" },
  { label: "All", value: "all" },
  { label: "At Minimum", value: "min" },
];

export const STATUS_OPTIONS = [
  {
    label: "In Draft",
    value: "In Draft",
  },
  {
    label: "Pre-Proposal",
    value: "Pre-Proposal",
  },
  {
    label: "Proposed",
    value: "Proposed",
  },
  {
    label: "Pre-Evaluation",
    value: "Pre-Evaluation",
  },
  {
    label: "In Progress",
    value: "In Progress",
  },
  {
    label: "Finalizing",
    value: "Finalizing",
  },
  {
    label: "Completed",
    value: "Certified",
  },
  {
    label: "Terminated",
    value: "Terminated",
  },
  {
    label: "Withdrawn",
    value: "Withdrawn",
  },
  {
    label: "Archived",
    value: "Archived",
  },
  {
    label: "In Assurance Maintenance",
    value: "In Assurance Maintenance",
  },
];
